<template>
  <div class="hs-search-bar" :class="type">
    <template v-if="type === 'style1'">
      <div class="bar">
        <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/hs-search-bar/search.png')})`}" @click="_search"></div>
        <input maxlength='50' @focus="$emit('focus')" v-model.trim="currentValue" :placeholder="placeholder" ref="HsSearchInput" @keyup.enter="$emit('keyupEnter')" />
        <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/close_gray.png')})`}" @click="$emit('clear')"></div>
      </div>
      <div class="cancel" @click="$emit('cancel')">{{$t('Cancel')}}</div>
    </template>

    <div class="bar" v-else>
      <input maxlength='50' @focus="$emit('focus')" v-model.trim="currentValue" :placeholder="placeholder" ref="HsSearchInput" />
      <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/plane-ticket/book/search.png')})`}" @click="_search"></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from 'vue'
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: Vue.prototype.$t('PleaseEnter_1')
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {}
  },
  mounted() {
    if (this.focus) {
      this.$refs.HsSearchInput.focus()
    }
  },
  methods: {
    _search() {
      this.$emit('delegate')
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-search-bar
  @extend .flex-center
  width 100%
  padding 5px 10px
  background-color $color_white
  >.bar
    @extend .flex-row
    @extend .flex-between
    width 100%
    border-radius 4px
    border 1px solid $color_gray_layer
    padding 10px
    background-color $color_white
    font-size 0.9rem
    >input
      width calc(100% - 30px)
      height 100%
    >.logo
      width 20px
      height 20px
      background-size 100% 100%
  .cancel
    @extend .flex-center
    height 40px
    flex-shrink 0
    font-size .9rem
    margin-left 10px
.style1
  >.bar
    border none
    border-radius 50vmin
    background $color_background_gray_3
    .logo
      width 15px
      height 15px
    >input
      background $color_background_gray_3
      font-size 13px
      padding 0 10px
.style2
  padding 10px 12px
  background $color_background_gray_2
  >.bar
    border none
</style>
